import { render, staticRenderFns } from "./editRequest.modal.vue?vue&type=template&id=1cb671b1"
import script from "./editRequest.modal.vue?vue&type=script&lang=js"
export * from "./editRequest.modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports